import React from "react";
import MentorProfileForm from "../forms/MentorProfileForm";
import Sidebar from "../Sidebar";

function MentorProfileInfo() {
  return (
    <Sidebar>
      <MentorProfileForm />
    </Sidebar>
  );
}

export default MentorProfileInfo;
